import type { Comp, GameObj } from "kaplay";
import type { Mountain } from "../systems/mountain";
import type { PlayerInputComp } from "./playerInput";
import type { RiderComp } from "./rider";

const LOOK_AHEAD_M = 15;
const SIDEWAYS_HEADING = 60;

export function autopilot(mountain: Mountain, sideways: boolean): Comp {
    return {
        id: "autopilot",
        require: ["playerInput", "rider"],
        update(this: GameObj<PlayerInputComp | RiderComp>) {
            const { x, y } = this.motion;
            const aheadX = mountain.trailAt(y + LOOK_AHEAD_M)?.x ?? x;
            const heading = sideways ? SIDEWAYS_HEADING : (Math.atan2(aheadX - x, LOOK_AHEAD_M) * 180) / Math.PI;
            this.intent = { ...this.intent, targetHeading: heading, steer: 0, pedal: true, brake: false };
        },
    };
}
